export default "/_next/static/src/assets/videos/1c3eddaf64333ad1e6c2bad69e9e03c5.mp4";